<template>
<div
    v-if="templates != null"
>
    <v-text-field
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        autocomplete="off"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickAdd()"
                     v-if="uncreated_templates != null && uncreated_templates.length > 0"
                >
                    <v-list-item-title>New...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

    <v-data-table
        v-if="templates != null"
        :headers="headers"
        :items="templates"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
        :search="full_text"
    >
    
        <template v-slot:item.send_from="{ item }">
            {{pretty_send_from(item)}}
        </template>

        <template v-slot:item.comp_best_send_mode="{ item }">
            <div
                :class="{'cell_manual': item.comp_best_send_mode == 'manual', 'cell_auto': item.comp_best_send_mode == 'auto', 'cell_disabled': item.comp_best_send_mode == 'disabled'}"
            >
            {{item.comp_best_send_mode.toUpperCase()}}
            </div>
        </template>

        <template v-slot:item.list_drip_delay="{ item }">
            {{$rc.pretty(item.list_drip_delay,'duration')}}
        </template>

        

        <template v-slot:item.message_patterns="{ item }">
            <ul
                v-if="item.message_patterns.length > 1"
            >
                <li
                    v-for="(message, index) in item.message_patterns"
                    :key="item.template_subject_id+'_'+index"
                >
                    {{message}}
                </li>
            </ul>
            <span
                v-else
            >   
                {{item.message_patterns[0]}}
            </span>
        </template>

        

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item v-on:click="onClickTemplateSettings(item)">
                    <v-list-item-title>Settings...</v-list-item-title>
                </v-list-item>

                <v-list-item v-on:click="onClickMessages(item)">
                    <v-list-item-title>Messages...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item v-on:click="onClickDelete(item)">    
                    <v-list-item-title>Delete...</v-list-item-title>
                </v-list-item>    

                <v-divider
                    v-if="item.upgrade_available_to != null"
                />

                <v-list-item 
                    v-if="item.upgrade_available_to != null"
                    v-on:click="onClickUpgrade(item)"
                >    
                    <v-list-item-title>Upgrade...</v-list-item-title>
                </v-list-item>   


            
                
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

    <m-icon-bar
        v-on:add="onClickAdd"
        v-if="uncreated_templates != null && uncreated_templates.length > 0"
    />

    <div
        style="background-color: rgba(255,0,0,0.3); border: 1px solid black; margin-top: 30px; padding: 15px;"
        v-if="any_messages_in_manual_mode"
    >
        You have message(s) that are <span style="font-family: monospace; font-weight: 700">MANUAL</span> mode.  These messages will not be sent unless you manually review and approve them.
    </div>

    <m-edit-select-dialog
        ref="select-new-template"
        v-on:ok="onCreateNewTemplate($event)"
    />

    <m-new-drip-message-dialog
        ref="new-drip-message-dialog"
        v-on:ok="update"
    />
</div>
</template>

<script>
export default {
    props: {

        organization_id: {
            type: String,
            default: function() { return this.$route.params.organization_id; }
        },

        show_column_type: {
            type: Boolean,
            default: function() { return true; }
        },

        show_column_patterns: {
            type: Boolean,
            default: function() { return false; }
        },

        show_column_delay: {
            type: Boolean,
            default: function() { return false; }
        },

        list_id: {
            type: String,
            default: function() { return null; }
        },

        show_list_label: {
            type: Boolean,
            default: function() { return true; }
        },
    },

    data() {
        return{
            organization_label: null,
            templates: null,
            uncreated_templates: null,
            full_text: null,

            
        }
    },

    mounted () {
        this.update();
    },

    methods: 
    {
        update()
        {
            this.$rc.showSpinner();

            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/auto-messages/org-profile',
            
                'params' : {
                        'organization_id': this.organization_id,
                        'list_id': this.list_id,
                    },
            
                'on_success': (data) => {
                        this.organization_label = data.organization_label;
                        this.templates = data.templates;
                        this.uncreated_templates = data.uncreated_templates;
                    },
            
                'on_error': 'Unable to get automated messages',
            });
        },

        onClickTemplateSettings(template)
        {
            this.$router.push({
                'name': 'auto-messages-template-settings',
                'params' : {
                    'organization_id' : template.organization_id,
                    'template_context' : template.template_context,
                    'template_subject_id': template.template_subject_id,
                }
            }).catch(e=>{}); // swallow any exception    
        },

        onClickDelete(template)
        {
            this.$rc.confirm(
                'Delete auto message template.',
                'Do you want to delete the template '+template.template_label+'.',
                [
                    {'text': 'Cancel', 'value': 'cancel'},
                    {'text': 'Confirm', 'value': 'confirm'},
                ],
                (response) => {
                    if (response == 'confirm') 
                        this.onDoDelete(template);
                }
            );
        },

        onDoDelete(template)
        {
            let params = {
                'organization_id' : template.organization_id,
                'template_context' : template.template_context,
                'template_subject_id': template.template_subject_id,
            };

            this.$rc.showSpinner();
            
            this.$rc.deleteAutoMessageTemplate(
                params,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.update();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to delete auto message template');
                },
            );
        },

        onClickAdd()
        {
            if ( this.list_id != null )
            {
                this.onClickAddDripMessage();
                return;
            }

            let choices = [];
            let ut = this.uncreated_templates;

            for ( let i = 0; i < ut.length; i++ )
            {
                choices.push({
                    'text' : ut[i].template_label,
                    'value' : ut[i].template_context,
                    'template' : ut[i],
                });
            }

            this.$refs['select-new-template'].showDialog('Select a new automatic message type', null, choices);
        },

        onClickAddDripMessage()
        {
            let send_from = null;

            if ( this.templates != null )
            {
                for ( let i = 0; i < this.templates.length; i++ )
                {
                    send_from = this.templates[i].send_from;
                    if ( send_from != null ) break;
                }
            }

            this.$refs['new-drip-message-dialog'].showDialog(this.organization_id, this.list_id, send_from);
        },

        onCreateNewTemplate(value)
        {
            let new_template = value.template;

            this.$rc.showSpinner();
            
            this.$rc.putAutoMessageTemplate(
                new_template,
            
                (data) => {
                    this.$rc.hideSpinner();

                   this.update();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to create automated message');
                },
            );
        },

        onClickMessages(template)
        {
            this.$router.push({
                'name': 'auto-messages-search-messages',
                'params' : {
                    'organization_id' : template.organization_id,
                    'template_context' : template.template_context,
                    'template_subject_id': template.template_subject_id,
                }
            }).catch(e=>{}); // swallow any exception    
        },

        pretty_send_from(item)
        {
            if ( item.send_from == null ) 
                return "Not set - no messages will be sent";

            let tn = this.$rc.pretty(item.send_from,'endpoint');

            if ( item.send_from_label == null ) 
                return tn;

            return item.send_from_label+" - "+tn;
        },

        onClickUpgrade(item)
        {
            this.$rc.confirm({
                'title': 'Upgrade to Second Generation Shipping Message',
                'body': 'Do you want to upgrade this automated message to use the new and improved automated shipping messages?<br/><br/>This can not be undone.',
                'btn_text_ok': 'Upgrade',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.doUpgrade(item);
                },
            });
        },

        doUpgrade(item)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/auto-messages/upgrade-automated-message',
            
                'params' : item,
            
                'on_success': (data) => {
                        this.update();
                    },
            
                'on_error': 'Unable to upgrade automated message template',
            });
        }
    },

    computed: 
    {

        any_messages_in_manual_mode() {
            if ( this.templates == null ) return false;

            for ( let i = 0; i < this.templates.length; i++ )
            {
                if ( this.templates[i].comp_best_send_mode == 'manual' )
                    return true;
            }

            return false;
        },

        headers() {
            let ret = [];
            
            if ( this.show_column_type )
            {
                ret.push({ text: 'Type', value: 'template_context'});
            }

            if ( this.show_column_delay )
            {
                ret.push({ text: 'Delay', value: 'list_drip_delay'});
            }

            if ( this.show_list_label )
            {
                ret.push({ text: 'List', value: 'list_drip_list_internal_label'});
            }
               
            ret.push({ text: 'Label', value: 'template_label'});
            ret.push({ text: 'Parameters', value: 'param_description'});

            if ( this.show_column_patterns )
            {
                ret.push({ text: 'Message', value: 'message_patterns'})
            }

            ret.push({ text: 'Send From', value: 'send_from'});
            ret.push({ text: 'Mode', value: 'comp_best_send_mode', align: 'center'});
            ret.push({ text: 'Action', value: 'action', align: 'right'});
            
            return ret;
        },
    },
}
</script>

<style lang="scss" scoped>

.cell_manual,
.cell_auto,
.cell_disabled
{
    text-align: center; 
    padding: 14px; 
    font-family: monospace;
}

.cell_manual
{
    background-color: rgba(255,0,0,0.3); 
}

.cell_auto
{
    background-color: rgba(0,255,0,0.3); 
}

.cell_disabled
{
    background-color: rgba(0,0,0,0.1); 
    color: rgba(0,0,0,0.5);
}
</style>